import { combineActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import ClientsType from '../types/ClientsType';
import GlobalTypes from '../types/GlobalType';
import DashboardType from '../types/DashboardType';
import AuthTypes from '../types/AuthType';
import GridFiltersType from '../types/GridFiltersType';
import MerchantsType from '../types/MerchantsType';
import TransactionType from '../types/TransactionType';
import GlobalToastType from '../types/GlobalToastType';
import TicketsType from '../types/TicketsType';
import AccountsType from '../types/AccountsType';
import SettingsTypes from '../types/SettingsTypes';
import TopUpTypes from '../types/TopUpTypes';
import RollingReserveType from '../types/RollingReserveType';
import SubMerchantsType from '../types/SubMerchantsType';

const initialState = {
  isLoading: false,
  error: null,
};

const startRequest = [
  GlobalTypes.actions.startRequest,
  AuthTypes.actions.signIn,
  AuthTypes.actions.activateMfa,
  AuthTypes.actions.authMfa,
  AuthTypes.actions.resetMFA,
  AuthTypes.actions.login,
  AuthTypes.actions.switchContext,
  AuthTypes.actions.forgotPass,
  AuthTypes.actions.resetPass,
  DashboardType.actions.fetchBalances,
  DashboardType.actions.fetchTickets,
  DashboardType.actions.fetchLibTimes,
  DashboardType.actions.fetchSignUpRequestDetails,
  AccountsType.actions.fetchPresets,
  TicketsType.actions.fetchTicketsDetails,
  SettingsTypes.actions.fetchFxData,
  SettingsTypes.actions.fetchFeeData,
  SettingsTypes.actions.fetchLimitsData,
  SettingsTypes.actions.fetchScheduledSettlement,
  TopUpTypes.actions.fetchTopUpDetails,
  TopUpTypes.actions.fetchTopUpCredits,
];
const endRequest = [
  GlobalTypes.actions.failedRequest,
  GlobalTypes.actions.successRequest,
  AuthTypes.actions.signInSuccess,
  AuthTypes.actions.activateMfaSuccess,
  AuthTypes.actions.authMfaSuccess,
  AuthTypes.actions.resetMFASuccess,
  AuthTypes.actions.loginSuccess,
  AuthTypes.actions.switchContextSuccess,
  AuthTypes.actions.logoutSuccess,
  AuthTypes.actions.forgotPassSuccess,
  AuthTypes.actions.resetPassSuccess,
  DashboardType.actions.fetchTicketsSuccess,
  DashboardType.actions.fetchBalancesSuccess,
  DashboardType.actions.fetchLibTimesSuccess,
  DashboardType.actions.fetchSignUpRequestDetailsSuccess,
  GridFiltersType.actions.fetchGridFiltersSuccess,
  TransactionType.actions.fetchTransactionDetailsSuccess,
  TransactionType.actions.fetchRefundDetailsSuccess,
  ClientsType.actions.fetchClientDetailsSuccess,
  ClientsType.actions.fetchClientHistorySuccess,
  GlobalToastType.actions.addToast,
  TicketsType.actions.fetchTicketsSuccess,
  AccountsType.actions.fetchPresetsSuccess,
  MerchantsType.actions.fetchMerchantsAllSuccess,
  TicketsType.actions.fetchTicketsDetailsSuccess,
  SettingsTypes.actions.fetchGeneralConfigSuccess,
  SettingsTypes.actions.fetchFxDataSuccess,
  SettingsTypes.actions.fetchFeeDataSuccess,
  SettingsTypes.actions.fetchLimitsDataSuccess,
  SettingsTypes.actions.fetchScheduledSettlementSuccess,
  SettingsTypes.actions.fetchChargebackFeeDataSuccess,
  SettingsTypes.actions.fetchReferralConfigSuccess,
  SettingsTypes.actions.fetchRollingReserveSuccess,
  SettingsTypes.actions.generateApiKeySuccess,
  TopUpTypes.actions.fetchTopUpDetailsSuccess,
  RollingReserveType.actions.fetchRollingReserveDetailsSuccess,
  SubMerchantsType.actions.fetchSubMerchantsDataSuccess,
  SubMerchantsType.actions.fetchPspMerchantsDataSuccess
];

export const Global = handleActions(
  {
    [combineActions(...startRequest)]: (state) => ({ ...state, isLoading: true, error: null }),
    [combineActions(...endRequest)]: (state) => ({ ...state, isLoading: false, error: null }),
    [GlobalTypes.actions.startLoader]: (state) => ({ ...state, isLoading: true }),
    [GlobalTypes.actions.endLoader]: (state) => ({ ...state, isLoading: false }),
    [GlobalTypes.actions.failedRequest]: (state, { payload: error }) => {
      return {
        ...state,
        error: {
          message:
            error.response !== undefined && Object.prototype.hasOwnProperty.call(error.response, 'data') ? error.response.data.description : error.message || 'Something went wrong.',
          code: error.response !== undefined && Object.prototype.hasOwnProperty.call(error.response, 'status') ? error.response.status : 500,
        },
      };
    },
  },
  initialState
);

const getGlobal = createSelector(
  (state) => state.Global,
  (global) => global
);

export const isLoading = createSelector(getGlobal, (global) => global.isLoading);

export const errorResponse = createSelector(getGlobal, (global) => global.error);
